var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"gallery",staticClass:"gallery"},_vm._l((_vm.data.value.gallery),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('Figure',{attrs:{"data":{
        value: {
          src: item,
        },
        settings: {},
      },"lazyload":false,"disable-ratio":""}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }